import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import TIM from 'tim-js-sdk'
import COS from 'cos-js-sdk-v5'
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'

const SdkAppId = process.env.NODE_ENV === 'development' ? 1400386304 : 1400379671;

Vue.prototype.$echarts = echarts
Vue.prototype.TIM = TIM
Vue.prototype.COS = COS
Vue.prototype.SDKAPPID = SdkAppId 
Vue.prototype.tim = TIM.create({SDKAppID: SdkAppId})
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
